import { render, staticRenderFns } from "./cost_info.vue?vue&type=template&id=24dfe032&scoped=true"
import script from "./cost_info.vue?vue&type=script&lang=js"
export * from "./cost_info.vue?vue&type=script&lang=js"
import style0 from "./cost_info.vue?vue&type=style&index=0&id=24dfe032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfe032",
  null
  
)

export default component.exports